import React from 'react';
import { Button } from '../../../components/ui/button';
import { InputField } from '../../../components/ui/input-field';
import { Search, Download, Filter, Plus } from 'lucide-react';
import ChannelsFiltersModal from './ChannelsFiltersModal';
import NuevoChannelModal from './NewChannelModal';

const statusOptions = ['Activo', 'Inactivo', 'Pendiente'];

interface ChannelsHeaderProps {
    onChannelAdded?: () => void;
}

const ChannelsHeader: React.FC<ChannelsHeaderProps> = ({ onChannelAdded }) => {
    const [showFiltersModal, setShowFiltersModal] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState('');
    const [showNewChannelModal, setShowNewChannelModal] = React.useState(false);

    return (
        <div className="space-y-6">
            {/* Title and Actions */}
            <div className="flex items-center justify-between place-items-center max-md:flex-col">
                {/* First row: title and input */}
                <div className="flex items-center w-full max-md:w-full max-md:mb-2">
                    <h1 className="text-2xl font-bold text-maxi-text-dark max-md:mr-2">Canales</h1>
                    <div className="relative flex-1 max-w-md max-md:w-full md:ml-auto">
                        <InputField
                            label=""
                            name="search"
                            value={""}
                            onChange={() => { }}
                            placeholder="Buscar"
                            className="pl-10 mt-4 bg-background border-maxi-border"
                            icon={<Search className="w-6 h-6 text-[#BDBDBD] flex-shrink-0" />}
                        />
                    </div>
                </div>
                {/* Second row: buttons */}
                <div className="flex items-center gap-3 w-full max-md:mt-2 justify-center md:justify-end">
                    <Button variant="default" className="gap-2 rounded-full">
                        <Download className="w-4 h-4" />
                        Exportar
                    </Button>
                    <Button variant="default" className="gap-2 rounded-full" onClick={() => setShowFiltersModal(true)}>
                        <Filter className="w-4 h-4" />
                        Filtros
                    </Button>
                    <Button variant="default" className="gap-2 rounded-full bg-primary text-primary-foreground hover:bg-primary/90" onClick={() => setShowNewChannelModal(true)}>
                        <Plus className="w-4 h-4" />
                        Nuevo Canal
                    </Button>
                </div>
            </div>
            <ChannelsFiltersModal
                open={showFiltersModal}
                onClose={() => setShowFiltersModal(false)}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                statusOptions={statusOptions}
                onClear={() => { setSelectedStatus(''); setShowFiltersModal(false); }}
                onApply={() => setShowFiltersModal(false)}
            />
            <NuevoChannelModal 
                open={showNewChannelModal} 
                onClose={() => setShowNewChannelModal(false)}
                onSuccess={() => {
                    setShowNewChannelModal(false);
                    onChannelAdded?.();
                }}
            />
        </div>
    );
};

export default ChannelsHeader;
